import React from 'react';

import { Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';

import { DPIA_TRIGGER_SOURCE_OPTIONS } from 'config/api/dpiaRequests/dpiaRequests.constants';
import processing_activities_messages from 'messages/processing_activities_messages';

import type { DpiaTriggerSummary } from './resolveDpiaTrigger';

type TriggerSourceMessageKey = keyof typeof processing_activities_messages.asset_ropa.dpia_need_assessment.trigger_sources;

type Props = {
  trigger: DpiaTriggerSummary;
};

const DpiaTriggerReadOnly: React.FC<Props> = ({ trigger }) => {
  const { t } = useTranslation();
  const sidePanel = processing_activities_messages.asset_ropa.owner_dpia.side_panel;
  const triggerSources = processing_activities_messages.asset_ropa.dpia_need_assessment.trigger_sources;
  const isKnownSource = trigger.triggerSource && (DPIA_TRIGGER_SOURCE_OPTIONS as readonly string[]).includes(trigger.triggerSource);
  const sourceLabel = isKnownSource ? t(triggerSources[trigger.triggerSource as TriggerSourceMessageKey]) : trigger.triggerSource;

  return (
    <>
      {sourceLabel && (
        <Typography variant='body2'>
          <strong>{t(sidePanel.trigger_source)}:</strong> {sourceLabel}
        </Typography>
      )}
      {trigger.triggerComment ? (
        <Typography color='textSecondary' variant='body2'>
          <strong>{t(sidePanel.trigger_comment)}:</strong> {trigger.triggerComment}
        </Typography>
      ) : null}
    </>
  );
};

export default DpiaTriggerReadOnly;
